import { render, staticRenderFns } from "./DocumentationPageAndroid.vue?vue&type=template&id=3e181083&scoped=true&"
import script from "./DocumentationPageAndroid.vue?vue&type=script&lang=js&"
export * from "./DocumentationPageAndroid.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPageAndroid.vue?vue&type=style&index=0&id=3e181083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e181083",
  null
  
)

export default component.exports